<template>
  <div
    v-if="hasCheckoutSalesTaxEnabled"
    class="p-4 bg-white max-w-lg card mb-4"
  >
    <div class="text-primary font-semibold">
      Tax
    </div>
    <div class="text-sm sm:max-w-[80%]">
      Seamlessly calculate and collect sales taxes at checkout with automated reporting.
    </div>
    <div class="flex justify-between items-center mt-4">
      <div class="text-sm font-semibold text-primary">
        <img
          src="./assets/avalara_logo.png"
          alt="Avalara Logo"
          class="w-[76.94px] self-start mb-2"
        >
        Avalara
      </div>
      <div
        v-if="!integrations.length"
        class="self-end"
      >
        <button
          class="text-center btn btn-primary btn-sm"
          @click="router.push({name: 'avalaraForm'})"
        >
          Connect
        </button>
      </div>
    </div>
    <CredentialsTable
      v-if="integrations && integrations.length"
      :integrations="integrations"
      @archive="emit('archive')"
    />
  </div>
</template>

<script setup lang="ts">
import {
  inject,
  Ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { ProjectState } from '@/pages/app/project/api/get_project_state';
import CredentialsTable from '../components/credentials_table.vue';

export interface Integration {
  id: string;
  displayName: string;
  projectId: string;
  integrationSource: string;
  integrationType: string
  state: 'authorized' | 'unauthorized' | 'validating';
  createdAt: string;
}

const emit = defineEmits([
  'archive',
]);

defineProps<{
  integrations: Integration[];
}>();

const router = useRouter();
const projectState = inject<Ref<ProjectState>>('project') as Ref<ProjectState>;
const hasCheckoutSalesTaxEnabled = projectState.value.features?.checkoutSalesTaxEnabled;
</script>
